import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import { TranslationService } from '@gv/ammo-grome';

@Component({})
export default class ParameterDatePickerRange extends Vue {
  @Inject('translationService') private translationService: () => TranslationService;

  private languages: any = this.$store.getters.languages;

  private currentLanguage = this.$store.getters.currentLanguage;

  @Prop({ required: true, type: String }) readonly value;

  @Prop({ required: true, type: String }) readonly label;

  @Prop({ required: true, type: Boolean }) readonly dark;

  public modal = false;

  public inputValue = '';

  public errorMessage = '';

  // ISO 8601 date format regex: YYYY-MM-DD
  private dateFormatRegex = /^\d{4}-\d{2}-\d{2}$/;

  created() {
    const currentLanguage = Object.keys(this.languages).includes(navigator.language) ? navigator.language : this.currentLanguage;
    this.translationService().refreshTranslation(currentLanguage);
    this.inputValue = this.value || '';
  }

  @Watch('value')
  onValueChange(newValue: string) {
    this.inputValue = newValue || '';
    this.errorMessage = '';
  }

  public input(payload) {
    this.$emit('input', payload);
    this.inputValue = payload;
    this.errorMessage = '';
  }

  public handleManualInput(value: string) {
    this.inputValue = value;
    // Clear error while typing
    if (this.errorMessage) {
      this.errorMessage = '';
    }
  }

  public onFocus() {
    // Clear error on focus
    this.errorMessage = '';
  }

  public validateDate() {
    if (!this.inputValue) {
      // Empty is valid (optional field)
      this.errorMessage = '';
      this.$emit('input', '');
      return;
    }

    // Check format
    if (!this.dateFormatRegex.test(this.inputValue)) {
      this.errorMessage = 'Invalid format. Use YYYY-MM-DD';
      return;
    }

    // Check if it's a valid date
    const [year, month, day] = this.inputValue.split('-').map(Number);
    const date = new Date(year, month - 1, day);

    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
      this.errorMessage = 'Invalid date';
      return;
    }

    // Valid date - emit the value
    this.errorMessage = '';
    this.$emit('input', this.inputValue);
  }
}
